import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class CompanyForm extends BaseComponent {
	
	constructor() {
		super();
		
		var companyForm = this;
		setTimeout(function(){
			companyForm.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>
		`;
	}
	
	init() {
		var companyForm = this;
		
		companyForm.formPanel = ElementUtil.create({
			tag: 'dl-form-panel',
			itemid: 'form',
			children: [
				{
					tag: 'fieldset',
					children: [
						{
							tag: 'legend',
							innerHTML: 'Company'
						},
						{
							tag: 'vaadin-form-layout',
							children: [
								{
									tag: 'vaadin-text-field',	
									label: 'Doing Business As',
									name: 'company.companyName',
									required: true,
									maxlength: 120
								},
								{
									tag: 'vaadin-text-field',	
									label: 'Business Phone',
									name: 'company.companyPhone',
									required: true,
									maxlength: 60									
								},
								{
									tag: 'vaadin-combo-box',
									label: 'Currency Code', 
									name: 'company.baseCurrencyCode',
									'item-value-path': 'code',
									'item-label-path': 'description',
									required: true,
									postinit: function(combo) {
										Service.getLookupService().getLookupValues('CurrencyCode').then(function(data){
											combo.items = data;
										});
									}									
								},
								{
									tag: 'vaadin-combo-box',
									label: 'Language Code', 
									name: 'company.baseLanguageCode',
									'item-value-path': 'code',
									'item-label-path': 'description',
									required: true,
									postinit: function(combo) {
										Service.getLookupService().getLookupValues('LanguageCode').then(function(data){
											combo.items = data;
										});
									}									
								},
								{
									tag: 'vaadin-combo-box',
									label: 'Carrier Type', 
									name: 'company.carrierType',
									'item-value-path': 'code',
									'item-label-path': 'description',
									required: true,
									postinit: function(combo) {
										Service.getLookupService().getLookupValues('CarrierType').then(function(data){
											combo.items = data;
										});
									}
								},
								{
									tag: 'vaadin-combo-box',
									label: 'Reporting TimeZone', 
									'helper-text': 'This will effect the timezone of data shown and reporting',
									name: 'company.baseTimeZone',
									'item-value-path': 'code',
									'item-label-path': 'description',
									required: true,
									placeHolder: 'System Default',
									postinit: function(combo) {
										Service.getLookupService().getLookupValues('TimeZone').then(function(data){
											combo.items = data;
										});
									}
								},
								{
									tag: 'div',
									children: [										
										{
											tag: 'vaadin-checkbox',									
											name: 'company.shipperFlag',
											label: 'Shipper'
										},
										{
											tag: 'vaadin-checkbox',									
											name: 'company.brokerFlag',
											label: 'Broker'
										},
										{
											tag: 'vaadin-checkbox',									
											name: 'company.carrierFlag',
											label: 'Carrier'
										}
									]
								},
								{
									tag: 'vaadin-text-field',	
									label: 'Reference Code',
									name: 'company.referenceCode',									
									maxlength: 80								
								},
								{
									tag: 'vaadin-text-field',	
									label: 'Carrier Id',
									name: 'company.carrierId',									
									maxlength: 80								
								}								
							]
						}
					]
				},
				{
					tag: 'fieldset',
					style: 'margin-top: 20px;',
					children: [
						{
							tag: 'legend',
							innerHTML: 'Contact'
						},
						{
							tag: 'vaadin-form-layout',
							children: [
								{
									tag: 'vaadin-text-field',
									label: 'First Name',
									name: 'companyContact.firstName',
									required: true,
									maxlength: 60
								},
								{
									tag: 'vaadin-text-field',
									label: 'Last Name',
									name: 'companyContact.lastName',
									required: true,
									maxlength: 60
								},
								{
									tag: 'vaadin-text-field',
									label: 'Job Title',
									name: 'companyContact.jobTitle',									
									maxlength: 120
								},
								{
									tag: 'vaadin-email-field',
									label: 'Email',									
									name: 'companyContact.email',
									required: true,
									maxlength: 255
								},									
								{
									tag: 'vaadin-text-field',
									label: 'Phone',
									name: 'companyContact.phone',
									required: true,
									maxlength: 120
								},									
								{
									tag: 'vaadin-text-field',
									label: 'Fax',
									name: 'companyContact.fax',									
									maxlength: 120
								}								
							]							
						}
					]
				},
				{
					tag: 'fieldset',
					style: 'margin-top: 20px;',
					children: [
						{
							tag: 'legend',
							innerHTML: 'Shipping Address'
						},
						{
							tag: 'vaadin-form-layout',
							children: [
								{
									tag: 'vaadin-text-field',
									label: 'Address Line 1',
									name: 'shippingAddress.addressLine1',
									required: true,
									maxlength: 255
								},
								{
									tag: 'vaadin-text-field',
									label: 'Address Line 2',
									name: 'shippingAddress.addressLine2',
									maxlength: 255
								},
								{
									tag: 'vaadin-text-field',
									label: 'Address Line 3',
									name: 'shippingAddress.addressLine3',									
									maxlength: 255
								},
								{
									tag: 'vaadin-text-field',
									label: 'City Name',									
									name: 'shippingAddress.cityName',
									required: true,
									maxlength: 255
								},
								{
									tag: 'vaadin-combo-box',
									itemid: 'shippingAddressState',
									label: 'State/Providence', 
									name: 'shippingAddress.state',
									'item-value-path': 'code',
									'item-label-path': 'description',
									required: true,
									postinit: function(combo) {
										Service.getLookupService().getLookupValues('StateProvCode').then(function(data){
											combo.items = data;
										});
									}
								},
								{
									tag: 'vaadin-text-field',
									label: 'Postal Code',									
									name: 'shippingAddress.postalCode',
									required: true,
									maxlength: 10
								}
							]							
						}
					]
				},
				{
					tag: 'fieldset',
					style: 'margin-top: 20px;',
					children: [
						{
							tag: 'legend',
							innerHTML: 'Billing Address'
						},
						{
							tag: 'vaadin-form-layout',
							children: [
								{
									tag: 'vaadin-text-field',
									label: 'Address Line 1',
									name: 'billingAddress.addressLine1',
									required: true,
									maxlength: 255
								},
								{
									tag: 'vaadin-text-field',
									label: 'Address Line 2',
									name: 'billingAddress.addressLine2',
									maxlength: 255
								},
								{
									tag: 'vaadin-text-field',
									label: 'Address Line 3',
									name: 'billingAddress.addressLine3',									
									maxlength: 255
								},
								{
									tag: 'vaadin-text-field',
									label: 'City Name',									
									name: 'billingAddress.cityName',
									required: true,
									maxlength: 255
								},
								{
									tag: 'vaadin-combo-box',
									itemid: 'billingAddressState',
									label: 'State/Providence', 
									name: 'billingAddress.state',
									'item-value-path': 'code',
									'item-label-path': 'description',
									required: true,
									postinit: function(combo) {
										Service.getLookupService().getLookupValues('StateProvCode').then(function(data){
											combo.items = data;
										});
									}
								},
								{
									tag: 'vaadin-text-field',
									label: 'Postal Code',									
									name: 'billingAddress.postalCode',
									required: true,
									maxlength: 10
								}
							]							
						}
					]
				}, 
				{
					tag: 'div',
					itemid: 'buttons',
					style: 'text-align: center;',
					children: [
						{
							tag: 'vaadin-button',
							theme: 'primary',
							style: 'margin-top: 20px;',
							children: [
								ElementUtil.makeIcon('vaadin:database', ' Save')
							],
							listeners: {
								click: function() {

									companyForm.formPanel.submitForm({
										preSubmit: function(data) {
											var unpacked = ElementUtil.dotNotationToObj(data);
											unpacked.shippingAddress.country = ElementUtil.query(companyForm.formPanel, 'shippingAddressState').selectedItem.country;
											unpacked.shippingAddress.addressType = 'SHIPTO';
											unpacked.billingAddress.country = ElementUtil.query(companyForm.formPanel, 'billingAddressState').selectedItem.country;
											unpacked.billingAddress.addressType = 'BILLTO';
											return unpacked;
										},
										actualCall: function(data) {
											return Service.getCompanyService().saveCompany(companyForm.loadedCompanyId, data);
										},
										success: function(data, responseData) {
											window.DL.MessageUtil.showToast('Success', 'Updated Company', {
												theme: 'success',
												position: 'top-stretch'
											});
											if (companyForm.successCallback) {
												companyForm.successCallback();
											}
										}
									});	

								}
							}
						}
					]
				}
							
			]
		});
		
		companyForm.append(companyForm.formPanel);		
		
		var readyEvent = new CustomEvent('ready', { detail: '' });
		companyForm.dispatchEvent(readyEvent);
	}
	
	loadCompany(companyId, flattenCompanyData) {
		var companyForm = this;
		companyForm.loadedCompanyId = companyId;				
		companyForm.formPanel.load(flattenCompanyData);
	}
	
	addActionButtons(buttons) {
		var companyForm = this;
		
		var buttonContainer = ElementUtil.query(companyForm.formPanel, 'buttons');
		buttonContainer.append(buttons);		
	}
	
};
customElements.define('dl-company-form', CompanyForm);
